<template>
  <div class="nx-searcher-filter-checkboxes">
    <v-checkbox
        v-for="item in options" :key="item"
        :label="$t(`message.searcher.filters.values.${filter}.${item}`)"
        :input-value="multipleValue"
        :disabled="disabled"
        :value="item"
        @change="updateFilter"
        hide-details
    ></v-checkbox>
    <div class="input-group__details"></div>
  </div>
</template>

<script>
import MultiValueFilter from '../mixins/MultiValueFilter';
import Filter from './Filter';

export default {
  name: 'nx-searcher-filter-checkboxes',
  extends: Filter,
  mixins: [MultiValueFilter],
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-searcher-filter-checkboxes {
  .v-input {
    margin-top: 0
  }
}
</style>
